import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "lookers_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addToCart = (product, lensUpgrade = false, lensPrice = 0) => {
    setItems((prev) => {
      if (prev.some((i) => i.product_id === product.id)) return prev;
      return [
        ...prev,
        {
          product_id: product.id,
          brand_name: product.brand_name,
          brand_slug: product.brand_slug,
          model: product.model,
          image: product.images?.[0]?.url,
          price: product.selling_price,
          original_rrp: product.original_rrp,
          lens_upgrade: lensUpgrade,
          lens_price: lensUpgrade ? lensPrice : 0,
          condition_score: product.condition_score,
          condition_label: product.condition_label,
          inventory_id: product.inventory_id,
        },
      ];
    });
  };

  const removeFromCart = (productId) => setItems((prev) => prev.filter((i) => i.product_id !== productId));
  const clearCart = () => setItems([]);
  const toggleLens = (productId, lensUpgrade, lensPrice) =>
    setItems((prev) => prev.map((i) => (i.product_id === productId ? { ...i, lens_upgrade: lensUpgrade, lens_price: lensUpgrade ? lensPrice : 0 } : i)));

  const subtotal = items.reduce((sum, i) => sum + i.price + (i.lens_price || 0), 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, clearCart, toggleLens, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
